'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash.template');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _errors = require('./errors');

var _typeChecks = require('./typeChecks');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GenericResource = function () {
    /**
     * @param apiEndpoint Endpoint used for this resource. Supports ES6 token syntax, e.g: "/foo/bar/${pk}"
     * @param options Customize options for this resource (see `Router.options`)
     */
    function GenericResource(apiEndpoint, options) {
        _classCallCheck(this, GenericResource);

        this.apiEndpoint = apiEndpoint;

        // Set options
        this._customOptions = options;

        // set parent to null
        this._parent = null;
    }

    _createClass(GenericResource, [{
        key: '_setParent',
        value: function _setParent(parent) {
            this._parent = parent;
        }
    }, {
        key: 'mutateResponse',
        value: function mutateResponse(responseData, response) {
            if ((0, _typeChecks.isFunction)(this.options.mutateResponse)) {
                return this.options.mutateResponse(responseData, response, this);
            }

            return responseData;
        }
    }, {
        key: 'getHeaders',
        value: function getHeaders() {
            var headers = _extends({}, this.options.defaultHeaders || {}, ((0, _typeChecks.isFunction)(this.options.headers) ? this.options.headers() : this.options.headers) || {});

            var cookieVal = (0, _util.serializeCookies)(this.getCookies());
            if (cookieVal) {
                headers.Cookie = cookieVal;
            }

            return headers;
        }
    }, {
        key: 'getCookies',
        value: function getCookies() {
            return _extends({}, this._parent ? this._parent.getCookies() : {}, ((0, _typeChecks.isFunction)(this.options.cookies) ? this.options.cookies() : this.options.cookies) || {});
        }
    }, {
        key: 'handleRequest',
        value: function handleRequest(req) {
            var _this = this;

            return this.ensureStatusAndJson(new Promise(function (resolve) {
                var headers = _this.getHeaders();

                if (headers && (0, _typeChecks.isObject)(headers)) {
                    Object.keys(headers).forEach(function (key) {
                        if ((0, _typeChecks.hasValue)(headers[key])) {
                            req = _this.setHeader(req, key, headers[key]);
                        }
                    });
                }

                _this.doRequest(req, function (response, error) {
                    return resolve(_this.wrapResponse(response, error, req));
                });
            }));
        }
    }, {
        key: 'ensureStatusAndJson',
        value: function ensureStatusAndJson(prom) {
            var _this2 = this;

            return prom.then(function (res) {
                // If no error occured
                if (res && !res.hasError) {
                    if (_this2.options.statusSuccess.indexOf(res.status) !== -1) {
                        // Got statusSuccess response code, lets resolve this promise
                        return _this2.mutateResponse(res.data, res);
                    } else if (_this2.options.statusValidationError.indexOf(res.status) !== -1) {
                        // Got statusValidationError response code, lets throw ValidationError
                        throw new _errors.ValidationError({
                            statusCode: res.status,
                            responseText: res.text
                        }, _this2.options);
                    } else {
                        // Throw a InvalidResponseCode error
                        throw new _errors.InvalidResponseCode(res.status, res.text);
                    }
                } else {
                    // res.hasError should only be true if network level errors occur (not statuscode errors)
                    var message = res && res.hasError ? res.error : '';
                    throw new _errors.NetworkError(message || 'Something went awfully wrong with the request, check network log.');
                }
            });
        }
    }, {
        key: 'buildThePath',
        value: function buildThePath(urlParams) {
            var thePath = this.apiEndpoint;

            if (urlParams && !((0, _typeChecks.isObject)(urlParams) && Object.keys(urlParams).length === 0)) {
                thePath = (0, _lodash2.default)(this.apiEndpoint)(urlParams);
            }

            return '' + this.options.apiRoot + thePath;
        }

        /* istanbul ignore next */

    }, {
        key: 'wrapResponse',
        value: function wrapResponse(res, error, req) {
            // eslint-disable-line class-methods-use-this, no-unused-vars
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'createRequest',
        value: function createRequest(method, url, query, data) {
            // eslint-disable-line class-methods-use-this, no-unused-vars
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'doRequest',
        value: function doRequest(req, resolve) {
            // eslint-disable-line class-methods-use-this, no-unused-vars
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'setHeader',
        value: function setHeader(req, key, value) {
            // eslint-disable-line class-methods-use-this, no-unused-vars
            throw new Error('Not implemented');
        }
    }, {
        key: 'parent',
        get: function get() {
            return this._parent;
        }
    }, {
        key: 'isBound',
        get: function get() {
            return !!this._parent || !!this._options;
        }
    }, {
        key: 'options',
        get: function get() {
            if (!this._options) {
                return (0, _util.mergeOptions)(_constants2.default, this._parent ? this._parent.options : null, this._customOptions);
            }

            return this._options;
        }
    }]);

    return GenericResource;
}();

exports.default = GenericResource;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/dist/base.js
// module id = 770
// module chunks = 0